export const APP_NAME = 'PenguinMod';
